import axios from "axios";
import { ApplyCorpModel, CorpInfoModel } from "models";
import { IAPIResult } from "models/interfaces";

export async function preCheck(options: ApplyCorpModel, token: string) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/entry/apply-corp/creation-check",
    options,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function create(options: ApplyCorpModel, token: string) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/entry/apply-corp/create",
    options,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
}

export async function updateCheck(options: CorpInfoModel) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/apply-corp/updation-check",
    options
  );
  return response.data;
}

export async function update(options: CorpInfoModel) {
  // await Utils.sleep(300);
  const response = await axios.put<IAPIResult>(
    "/api.d/v1/ec/apply-corp/update",
    options
  );
  return response.data;
}

export async function del() {
  const response = await axios.delete<IAPIResult>(
    "/api.d/v1/ec/apply-corp/delete",
  );
  return response.data;
}
